export const AUTH_LOGIN_ERROR = 'Unable to sign you in. Check your credentials and try again.';
export const SIGN_IN_TITLE_LEAD = 'Sign';
export const SIGN_IN_TITLE_TAIL = 'In';
export const SIGN_IN_PRODUCT_SELECTION_HEADER_LEAD = 'Access';
export const SIGN_IN_PRODUCT_SELECTION_HEADER_TAIL = 'to Scalar App';
export const SIGN_IN_PRODUCT_SELECTION_PROMPT = 'Choose an option to navigate';
export const SIGN_IN_FIRM_SELECTION_HEADER_LEAD = 'Select';
export const SIGN_IN_FIRM_SELECTION_HEADER_TAIL = 'a Firm';
export const SIGN_IN_COMPANY_SELECTION_HEADER_LEAD = 'Select';
export const SIGN_IN_COMPANY_SELECTION_HEADER_TAIL = 'a Company';
export const SIGN_IN_IDENTIFIER_LABEL = 'Username';
export const SIGN_IN_IDENTIFIER_PLACEHOLDER = 'johndoe@scalar.io';
export const SIGN_IN_IDENTIFIER_REQUIRED_ERROR = 'Enter your username.';
export const SIGN_IN_IDENTIFIER_FORMAT_ERROR = 'Enter a valid username.';
export const SIGN_IN_PASSWORD_LABEL = 'Password';
export const SIGN_IN_PASSWORD_PLACEHOLDER = '************';
export const SIGN_IN_PASSWORD_REQUIRED_ERROR = 'Enter your password.';
export const SIGN_IN_PASSWORD_INVALID_ERROR = 'No active account found with the given credentials';
export const SIGN_IN_ACTIVATION_RECOVERY_PROMPT = 'If this is a new account and you have not activated it yet,';
export const SIGN_IN_REMEMBER_ME_LABEL = 'Stay signed in for 30 days';
export const SIGN_IN_FORGOT_PASSWORD_LABEL = 'Forgot Password?';
export const SIGN_IN_IDENTIFIER_SUBMIT_LABEL = 'Next';
export const SIGN_IN_PASSWORD_SUBMIT_LABEL = 'Sign In';
export const SIGN_IN_FOOTER_PROMPT = 'Don\'t have an account?';
export const SIGN_IN_FOOTER_SIGN_UP_LABEL = 'Sign up';
export const SIGN_IN_FOOTER_SKIP_LABEL = 'Skip for now';
export const SIGN_IN_SSO_PASSWORD_ALTERNATIVE_LABEL = 'SSO';
export const SIGN_IN_TERMS_AGREEMENT_LEAD = 'By checking this box, you agree to Scalar\'s';
export const SIGN_IN_TERMS_AGREEMENT_MIDDLE = 'and confirm you have read Scalar\'s';
export const SIGN_IN_TERMS_SIGN_OUT_LABEL = 'Sign out';
export const SIGN_IN_TERMS_SUBMIT_LABEL = 'Next';
export const SIGN_IN_TERMS_SAVE_ERROR = 'Unable to save your agreement right now. Please try again.';
